import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import AuthDialog from './AuthDialog';
import { useState } from 'react';

interface SessionExpiredDialogProps {
  open: boolean;
  onClose: () => void;
  onLogin: () => void;
}

export default function SessionExpiredDialog({ open, onClose, onLogin }: SessionExpiredDialogProps) {
  const [showAuthDialog, setShowAuthDialog] = useState(false);

  const handleLogin = () => {
    onClose();
    setShowAuthDialog(true);
  };

  const handleAuthDialogClose = () => {
    setShowAuthDialog(false);
    onLogin();
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Session Expired</DialogTitle>
        <DialogContent>
          <Typography>
            Your session has expired. Please log in again to continue.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit">
            Close
          </Button>
          <Button onClick={handleLogin} variant="contained" color="primary" autoFocus>
            Login
          </Button>
        </DialogActions>
      </Dialog>
      <AuthDialog
        open={showAuthDialog}
        onClose={handleAuthDialogClose}
        mode="login"
      />
    </>
  );
}